export default "__VITE_ASSET__DVugrgdX__"